import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
        , padding: 20
    },
    avatar: {
        flex: 1
        , justifyContent: 'flex-start'
        , alignItems: 'flex-start'
        , alignSelf: 'flex-start'
    },
    identity: {
        flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    badgeStyle: {
        borderRadius: 10
        , marginRight: 15
    },
    badgeImageStyle: {
        borderRadius: 20
        , borderWidth: 4
        , borderColor: 'white'
        , width: 40
        , height: 40
    },
    username: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    street: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    statement: {
        flex: 1
        , justifyContent: 'flex-start'
        , alignItems: 'flex-end'
        , alignSelf: 'flex-end'
    },
    statementImg: {
        marginRight: 10
        , width: 18
        , height: 18
    },
    statementTxt: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.TRANS_NEW_COLOR
    },
    dotNew: {
        backgroundColor: STYLES.TRANS_NEW_COLOR
        , width: 8
        , height: 8
        , borderRadius: 4
        , marginRight: 3
        , marginTop: 3
        , marginBottom: 3
    },
    dotRecurring: {
        backgroundColor: STYLES.TRANS_RECURRING_COLOR
        , width: 8
        , height: 8
        , borderRadius: 4
        , marginRight: 3
        , marginTop: 3
        , marginBottom: 3
    },
    byline: {
    },
    bylineTxt: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
        , marginBottom: 6
    },
    byline2Txt: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    cardStyle: {
        flex: 6
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'stretch'
    },
    datePicker: {
        flexShrink: 1
        , flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'stretch'
    },
    datePickerText: {
        fontSize: 12
        , color: STYLES.PRIMARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/containers/listboard/styles.js